const _ = "styles-module__button___wGa0X", s = "styles-module__primary___rrwuv", o = "styles-module__secondary___HFQtx", t = "styles-module__ghost___BbfDw", l = "styles-module__warning___sFuON", n = "styles-module__link___3Pmwm", e = "styles-module__label___lKQb1", c = "styles-module__small___c40XF", u = "styles-module__tiny___bNj8r", y = "styles-module__iconL___tTnHQ", d = "styles-module__iconR___cDbao", i = "styles-module__content___v9Hoa", m = {
  button: _,
  primary: s,
  secondary: o,
  ghost: t,
  "ghost--color-icon": "styles-module__ghost--color-icon___M7MPJ",
  warning: l,
  link: n,
  label: e,
  small: c,
  default: "styles-module__default___s0Wij",
  tiny: u,
  iconL: y,
  iconR: d,
  "full-width": "styles-module__full-width___uDroR",
  content: i
};
export {
  _ as button,
  i as content,
  m as default,
  t as ghost,
  y as iconL,
  d as iconR,
  e as label,
  n as link,
  s as primary,
  o as secondary,
  c as small,
  u as tiny,
  l as warning
};
